export const ListingSummaryFeature = {
  Beds: 'beds',
  Baths: 'baths',
  Sqft: 'finishedSqft',
  Community: 'community',
};

export const ListingSummaryTitle = {
  Community: 'Community',
};
